import styled from 'styled-components';

export const ArrowButton = styled.button<{ $transparent: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: ${props => props.$transparent ? 'transparent' : 'var(--t-icon-btn-primary-bg-color, #eeeeee)'};
  color: var(--t-brand-fg-color, #1c1c1c);
  cursor: pointer;
  transition: background-color 0.2s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    background-color: ${props => props.$transparent ? 'rgba(0, 0, 0, 0.1)' : 'var(--t-icon-btn-hover-bg-color, #000000)'};
    color: ${props => props.$transparent ? 'var(--t-brand-fg-color, #1c1c1c)' : 'var(--t-icon-btn-hover-color, #ffffff)'};
  }

  &:focus-visible {
    outline: 2px solid var(--t-brand-fg-color, #1c1c1c);
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  .icon {
    width: 1.5rem;
    height: 1.5rem;
  }
`;